const firebaseConfig = {


  apiKey: "AIzaSyCDdhnUDkQfMs668ULZ0IIbWpqdtYFvNDw",
  authDomain: "bike-sales-bd.firebaseapp.com",
  projectId: "bike-sales-bd",
  storageBucket: "bike-sales-bd.appspot.com",
  messagingSenderId: "163683820603",
  appId: "1:163683820603:web:76a90d644fd924b741e81e"
};

export default firebaseConfig;




